module.exports = __webpack_public_path__ + "img/permanentIncome.45ac960c.webp";